import type { CodigoError } from '../api';
import type { TipoAccion } from './cola';

/**
 * Telemetría mínima de fallos de cola.
 *
 * Para qué: cuando un LM diga "la app no me ha subido los tickets", hay que
 * poder mirar si fue la red, la clave, o un fallo nuestro — sin pedirle que
 * reproduzca nada estando ya de vuelta en la oficina.
 *
 * Qué se manda: tipo de acción, código de error y número de intento. Nada más.
 * NO se manda el contenido de la foto, ni el importe, ni el concepto, ni el
 * nombre del cliente visitado. El servidor ya sabe quién es por la sesión.
 *
 * Nunca falla hacia fuera: si el aviso no llega, la app sigue igual. Sería
 * absurdo que la telemetría de un fallo provocara otro.
 */
export async function informarDeFallo(
  tipo: TipoAccion,
  codigo: CodigoError | null,
  intentos: number,
): Promise<void> {
  // Sin red no tiene sentido intentarlo, y es justo el caso más frecuente.
  if (typeof navigator !== 'undefined' && navigator.onLine === false) return;

  try {
    await fetch('/api/telemetria/cola', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ tipo, codigo, intentos }),
      keepalive: true,
    });
  } catch {
    // Silencio deliberado.
  }
}
